import React from "react";

interface Props {
  title?: string;
  percentageChange: number | undefined;
}

const PercentageChange: React.FC<Props> = ({
  percentageChange = 0,
  ...otherProps
}) => {
  if (!percentageChange) {
    return null;
  }

  // TODO: use Tailwind classes
  return (
    <div
      style={{
        borderRadius: 5,
        marginLeft: 10,
        display: "inline",
        height: "auto"
      }}
      {...otherProps}
    >
      <span
        style={{
          color: percentageChange > 0 ? "#32C48D" : "rgb(232, 97, 97)",
          fontWeight: 400,
          fontSize: "12px",
          whiteSpace: "nowrap"
        }}
      >
        {formatPercentChangeString(percentageChange)}
      </span>
    </div>
  );
};

export default PercentageChange;

//
// Utils
//

export const formatPercentChangeString = (percentChangeNumber: number) => {
  const percentChangeString =
    percentChangeNumber === 0
      ? // if there wasn't a percentage change (both value and previousValue are 0), don't show the indicator
        ``
      : `${
          percentChangeNumber > 0 ? "+" : ""
        }${percentChangeNumber?.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })}%`;
  return percentChangeString;
};

export const calculatePercentChange = (
  value: number,
  previousValue: number
) => {
  const percentChangeValue =
    (value === 0 && previousValue === 0) || previousValue === 0
      ? // if both the period and the previous period rewards were 0, or the previous value is 0, set percent change to 0
        0
      : ((value - previousValue) / previousValue) * 100;
  return percentChangeValue;
};
